import React from 'react';
import { Hand, Search, Handshake } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
import { EditorialNum } from './EditorialNum';

const STEPS = [
  {
    n: '01',
    icon: Hand,
    title: 'Marca o que tem',
    text: 'Toca na figurinha pra registrar. Toca de novo pra contar repetidas. Segura pra zerar.',
  },
  {
    n: '02',
    icon: Search,
    title: 'Vê o que falta',
    text: 'Filtros e busca por seleção, código ou número. Em segundos sabe onde o álbum tá faltando.',
  },
  {
    n: '03',
    icon: Handshake,
    title: 'Acha o match',
    text: 'Cola a lista do amigo ou vira amigo no app. A gente cruza e mostra o que troca.',
  },
];

export function HowItWorks() {
  return (
    <section className="py-16 md:py-24 bg-paper">
      <div className="max-w-shell mx-auto px-4 md:px-6">
        <div className="max-w-md">
          <SectionLabel tone="green">Como funciona</SectionLabel>
          <h2 className="font-display font-bold text-h1 md:text-[36px] leading-tight text-ink-900 mt-3">
            Três passos pra fechar o álbum.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-10">
          {STEPS.map((step) => {
            const Icon = step.icon;
            return (
              <div
                key={step.n}
                className="bg-white rounded-2xl border border-ink-300 p-6 md:p-7 flex flex-col gap-4 shadow-xs"
              >
                <div className="flex items-center justify-between">
                  <EditorialNum n={step.n} size="md" />
                  <span className="w-11 h-11 rounded-full bg-green-100 flex items-center justify-center">
                    <Icon size={22} strokeWidth={2.25} className="text-green-700" />
                  </span>
                </div>
                <h3 className="font-display font-semibold text-h3 text-ink-900">{step.title}</h3>
                <p className="font-body text-body text-ink-700 leading-relaxed">{step.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
